import React from 'react';
import styled from 'styled-components';
import { zPositions } from '@/constants';
import { CheckboxProps } from 'antd/lib/checkbox';

import { Checkbox, Icon, Text, Title, Tooltip } from 'components';
import { kebabCase } from 'lodash';
import { useContactState } from './hooks';
import { NotificationOptions } from './types';

const NOTIFICATION_KEY_LABEL_LIST: {
  key: keyof NotificationOptions;
  label: string;
}[] = [
  { key: 'Booked', label: 'Booked' },
  { key: 'Confirmed', label: 'Confirmed' },
  { key: 'Cancelled', label: 'Cancelled' },
  { key: 'Deny', label: 'Denied' },
  { key: 'Time Change', label: 'Time Change' },
  { key: 'Action Required', label: 'Reminders' },
  { key: 'Feedback Collected', label: 'Feedback Collected' },
];

const SendNotifications: React.FC = () => {
  const [contactState, updateContactState] = useContactState();
  const { type, notifications, email, rep } = contactState;
  const createCheckValueChangeHandler =
    (key: string): CheckboxProps['onChange'] =>
    e => {
      const updatedNotificationOptions = {
        ...notifications,
        [key]: e.target.checked,
      };

      updateContactState({ notifications: updatedNotificationOptions });
    };
  const isFeedbackDisabled = !email && (!rep || type !== 'Agent');
  return (
    <StyledContainer>
      <Title level={2} data-cy="send-notification-title">
        Send Notifications
        <Tooltip
          zIndex={zPositions.contactModalComponents}
          title={
            'Enabling a notification will allow this contact to ' +
            'receive an email and / or SMS message for that particular showing update.'
          }
        >
          <Inline>
            <Icon type="antdInfoCircleFilled" color="black" />
          </Inline>
        </Tooltip>
      </Title>

      <StyledNotificationSettingsContainer>
        {NOTIFICATION_KEY_LABEL_LIST.map(({ key, label }) => {
          if (key === 'Feedback Collected') {
            if (type === 'Concierge') return null;
            return (
              <div key={key} data-cy={`edit-contact-row-${kebabCase(label)}`}>
                <Tooltip
                  title="User requires email."
                  placement="topLeft"
                  {...(!isFeedbackDisabled && { visible: false })}
                >
                  <Checkbox
                    checked={notifications[key]}
                    onChange={createCheckValueChangeHandler(key)}
                    disabled={isFeedbackDisabled}
                    data-cy={`edit-contact-checkbox-${kebabCase(label)}`}
                  >
                    <Text strong>{label}</Text>
                  </Checkbox>
                </Tooltip>
              </div>
            );
          }

          return (
            <div key={key} data-cy={`edit-contact-row-${kebabCase(label)}`}>
              <Checkbox
                checked={notifications[key]}
                onChange={createCheckValueChangeHandler(key)}
              >
                <Text strong>{label}</Text>
              </Checkbox>
            </div>
          );
        })}
      </StyledNotificationSettingsContainer>
    </StyledContainer>
  );
};

export default SendNotifications;

const StyledContainer = styled.div`
  display: grid;
`;

const StyledNotificationSettingsContainer = styled.div`
  display: grid;
  gap: 8px;
`;

const Inline = styled.div`
  display: inline-block;
  margin-left: 8px;
`;
